export enum AuditModes {
  InProgress = 'W trakcie',
  Other = 'Inne',
}
